import baseRequest from "../_core/baseRequest";

export default {
    getPoolList: params =>
        baseRequest.get(
            `/pools/list?${params?.city ? "&city=" + params.city : ""}${
                params.integrationType ? "&integrationType=" + params.integrationType : ""
            }${params.page ? "&page=" + params.page : ""}${
                params.limit ? "&limit=" + params.limit : ""
            }`
        ),
    getPool: params => baseRequest.get(`/pools/${params.poolId}`),
    createPool: params => baseRequest.post(`/pools`, params),
    updatePool: ({poolId, ...params}) => baseRequest.put(`/pools/${poolId}`, params),
    updatePoolCouriers: params => baseRequest.put(`/pools/${params.poolId}/couriers`, params),
    getPoolPaymentContracts: params =>
        baseRequest.get(`/pools/${params.poolId}/payment-contracts`, params),

    createPoolPaymentContract: params => baseRequest.post(`/pools/createPaymentContract`, params),

    /* havuz bölgesine ait yetkili kullanıcıları listeler */
    getPoolAuthorizedUsers: props => baseRequest.post(`pools/getPoolAuthorizedUsers`, props),

    /* havuz bölgesine ait yetkili kullanıcıları günceller */
    setPoolAuthorizedUsers: props => baseRequest.post(`pools/setPoolAuthorizedUsers`, props),

    /* kullanıcının yetkili olduğu havuzları listeler */
    getUserPools: params => baseRequest.get(`/pools/getUserPools`, params),

    createPoolMergeOptions: params => baseRequest.post(`/pools/mergeOptions`, params),

    updatePoolMergeOptions: params => baseRequest.put(`/pools/mergeOptions`, params),

    getPoolMergeOptions: params => baseRequest.get(`/pools/mergeOptions?poolId=${params.poolId}`),

    getPoolSubCompanies: params =>
        baseRequest.get(
            `/pools/mergeOptions/subCompanies?poolId=${params.poolId}&courierType=${
                params.courierType
            }${params.filter ? "&filter=" + params.filter : ""}`
        ),

    deletePoolMergeOptions: params => baseRequest.delete(`/pools/mergeOptions`, params),

    updateStatusPoolMergeOptions: params => baseRequest.put(`/pools/mergeOptions/status`, params),

    updateAllSubCompaniesMergeOptions: params =>
        baseRequest.put(`/pools/mergeOptions/subCompanies`, params),

    getPoolH3Cells: params =>
        baseRequest.get(
            `/pools/h3Cells?${params?.city ? "&city=" + params.city : ""}${
                params.integrationType ? "&integrationType=" + params.integrationType : ""
            }${params.page ? "&page=" + params.page : ""}${
                params.limit ? "&limit=" + params.limit : ""
            }`
        ),
    isSubcompanyDedicateIntegration: params =>
        baseRequest.post(
            "/delivery/courier-end-day-report/is-subcompany-dedicate-integration",
            params
        ),

    getPoolSupporters: params => baseRequest.get(`/pools/${params.poolId}/supporters`),
    getPoolSupportings: params => baseRequest.get(`/pools/${params.poolId}/supportings`),

    deletePoolSupporter: ({poolId, supportId}) =>
        baseRequest.delete(`/pools/${poolId}/supporter/${supportId}`),

    updatePoolSupporter: ({poolId, supportId, ...params}) =>
        baseRequest.put(`/pools/${poolId}/supporter/${supportId}`, params),

    updateSupporterActive: ({poolId, supportId, isActive}) =>
        baseRequest.patch(`/pools/${poolId}/supporter/${supportId}`, {isActive}),

    createPoolSupporter: ({poolId, ...params}) =>
        baseRequest.post(`/pools/${poolId}/supporter`, params),
    isDedicatedIntegration: params =>
        baseRequest.get(`/pools/authorizedPoolIntegrationType`, params)
};
